type Event = { event: string } & Record<string, any>

declare global {
  interface Window {
    dataLayer?: Event[]
  }
}

if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer ?? []
}

export function pushToGTM(event: Event) {
  window?.dataLayer?.push(event)
}
